"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    /**
     * Children are users who do not use the application directly
     * but are managed by volunteers and administrators.
     */
    Role[Role["CHILD"] = 0] = "CHILD";
    /**
     * Volunteers are users who use the application to manage groups
     * and register attendance.
     */
    Role[Role["VOLUNTEER"] = 1] = "VOLUNTEER";
    /**
     * Administrators are users who have full control over the application.
     * They can create, edit, and delete users, locations and groups.
     */
    Role[Role["ADMINISTRATOR"] = 2] = "ADMINISTRATOR";
    /**
     * API users do not exist within the application but use their account
     * to query the API. They have access to almost all data but are restricted to reading.
     */
    Role[Role["EXTERNAL_USER"] = 3] = "EXTERNAL_USER";
    /**
     * System administrators have full control over the application.
     */
    Role[Role["SYSTEM_ADMINISTRATOR"] = 4] = "SYSTEM_ADMINISTRATOR";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=role.enum.js.map